import {Component} from "react";
import {WindowParamContext} from "../../library/context/WindowContext";
import Markdown from "react-markdown";
import {ColumnUnit} from "../../library/atomic/unit/ColumnUnit";
import {SizeAttr} from "../../library/basic/size";
import {ColumnAttr} from "../../library/basic/compose";
import { Remarkable } from 'remarkable';
import './MdPage.css';

var rmd = new Remarkable();

export class MdPage extends Component {
    static contextType = WindowParamContext;

    state = {
        markDownText: ""
    }

    componentDidMount() {
        const membershipAgreementPath = require("../../assets/markdown/windflow-membership-agreement.md");
        const privacyPolicyPath = require("../../assets/markdown/windflow-privacy-policy.md");
        const userAgreementPath = require("../../assets/markdown/windflow-user-agreement-without-membership.md");
        const licensePath = require("../../assets/markdown/windflow-license.md");
        const contactPath = require("../../assets/markdown/windflow-contact.md");

        let mdPath = userAgreementPath
        if (window.location.pathname.includes("membership")) {
            mdPath = membershipAgreementPath
        } else if (window.location.pathname.includes("privacypolicy")) {
            mdPath = privacyPolicyPath
        } else if (window.location.pathname.includes("license")) {
            mdPath = licensePath
        } else if (window.location.pathname.includes("contact")) {
            mdPath = contactPath
        }
        fetch(mdPath).then(res => res.text()).then(text => {
            this.setState({markDownText: text})
            let dom = document.getElementById("md-box");
            if (dom != null) {
                dom.innerHTML = rmd.render(text)
            }
        });
    }

    render() {
        return (
            <WindowParamContext.Consumer>
                {wpt => {
                    let wp = wpt.param;

                    return (
                        <ColumnUnit customStyleAttr={ColumnAttr.getChildrenPositionObj()}
                                    sizeAttr={new SizeAttr(wp, "96vw")}>
                            {/*<Markdown>*/}
                            {/*    {this.state.markDownText}*/}
                            {/*</Markdown>*/}
                            <div id={"md-box"}>

                            </div>
                        </ColumnUnit>
                    )
                }
                }
            </WindowParamContext.Consumer>
        )
    }
}


